 <div class="content h-full">
  <div>
    <h3 class="mb-0">Properties</h3>
    <markdown [data]="propertiesDocs()" (click)="onMarkdownLinkClick($event)"></markdown>
    <!-- <div [innerHTML]="doc()?.propertiesDocs || 'No properties found'"></div> -->
  </div>

  <div>
    <h3 class="mb-0">Methods (WIP)</h3>
    <markdown [data]="methodsDocs()" (click)="onMarkdownLinkClick($event)"></markdown>
  </div>

  <section *ngIf="relatedTypesDocs() as rel">
    <markdown [data]="rel" (click)="onMarkdownLinkClick($event)"></markdown>
  </section>
</div>
